// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.flex-container {
    display: flex;
    gap: 10px;
    margin-top: 10px;
    margin-bottom: 30px;
}

.metric-select {
    flex: 0 0 40%;
    margin-right: 150px;
}

.date-select {
    flex: 0 0 25%;
}
`, "",{"version":3,"sources":["webpack://./src/components/reportes-components/Reportes/ReporteMetrica.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB","sourcesContent":["\r\n.flex-container {\r\n    display: flex;\r\n    gap: 10px;\r\n    margin-top: 10px;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.metric-select {\r\n    flex: 0 0 40%;\r\n    margin-right: 150px;\r\n}\r\n\r\n.date-select {\r\n    flex: 0 0 25%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
